// extracted by mini-css-extract-plugin
export var standaloneTable = "_gz-0";
export var standaloneTableWithBodyFill = "_gz-1";
export var withExtraHeader = "_gz-2";